import './Swimlanes.scss'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import CustomDragLayer from './CustomDragLayer'

import withScrolling, { createHorizontalStrength, createVerticalStrength } from 'frontend-collective-react-dnd-scrollzone'
import { TASK_NOT_STARTED_PERCENT } from '../../../constants/taskConstants'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Lane from './Lane'
import find from 'lodash/find'

const ScrollZone = withScrolling('div')
const hStrength = createHorizontalStrength(300)
const vStrength = createVerticalStrength(300)

class Swimlanes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollLeft: 0,
      scrollTop: 0,
      placeHolder: {
        laneId: null,
        nextTaskId: null
      }
    }
  }

  setPlaceHolder = (placeHolder) => {
    if (this.state.placeHolder.nextTaskId !== placeHolder.nextTaskId ||
        this.state.placeHolder.laneId !== placeHolder.laneId) {
      this.setState({
        placeHolder: {
          laneId: placeHolder.laneId,
          nextTaskId: placeHolder.nextTaskId,
          sourceLaneId: placeHolder.sourceLaneId || this.state.placeHolder.sourceLaneId,
          taskId: placeHolder.taskId || this.state.placeHolder.taskId
        }
      })
    }
  }

  onCardDrop = () => {
    this.props.onCardDrop({
      taskId: this.state.placeHolder.taskId,
      nextTaskId: this.state.placeHolder.nextTaskId,
      sourceLaneId: this.state.placeHolder.sourceLaneId,
      targetLaneId: this.state.placeHolder.laneId
    })
    this.setState({
      placeHolder: {
        laneId: null,
        nextTaskId: null
      }
    })
  }

  getAddLaneId = (swimlanes) => {
    const notStartedLane = find(swimlanes, swimLane => {
      return swimLane.mapping.startPercent === TASK_NOT_STARTED_PERCENT &&
        swimLane.mapping.endPercent === TASK_NOT_STARTED_PERCENT
    })

    return notStartedLane ? notStartedLane.id : -1
  }

  render() {
    const addLaneId = this.getAddLaneId(this.props.swimlanes)
    return (
      <ScrollZone
        horizontalStrength={hStrength}
        verticalStrength={vStrength}
        onScroll={(event) => this.setState({
          scrollLeft: event.target.scrollLeft,
          scrollTop: event.target.scrollTop
        })}
        className='board-container'>
        <div className='board'>
          {this.props.swimlanes.map(lane => (
            <Lane
              key={lane.id}
              lane={lane}
              scrollLeft={this.state.scrollLeft}
              scrollTop={this.state.scrollTop}
              tasks={this.props.tasks[lane.id]}
              onCardDrop={this.onCardDrop}
              onCardAdd={
                lane.id === addLaneId && this.props.project.actions.addTask && !this.props.isFilteredView
                ? this.props.onCardAdd
                : null
              }
              isAddingTask={lane.id === addLaneId && this.props.isAddingTask}
              taskAddCancel={this.props.taskAddCancel}
              taskAddSave={this.props.taskAddSave}
              setPlaceHolder={this.setPlaceHolder}
              placeHolder={this.state.placeHolder}
            />
          ))}
          <CustomDragLayer />
        </div>
      </ScrollZone>
    )
  }
}

Swimlanes.propTypes = {
  swimlanes: PropTypes.array.isRequired,
  project: PropTypes.object,
  tasks: PropTypes.object.isRequired,
  onCardDrop: PropTypes.func,
  onCardAdd: PropTypes.func,
  isAddingTask: PropTypes.bool,
  isFilteredView: PropTypes.bool,
  taskAddCancel: PropTypes.func.isRequired,
  taskAddSave: PropTypes.func.isRequired
}

export default DragDropContext(HTML5Backend)(Swimlanes)



// WEBPACK FOOTER //
// ./src/routes/Board/components/Swimlanes.js